module.exports = __webpack_public_path__ + "h5/img/dsh.74de2d34.png";